import GradoService from "@/api/services/cobranza/nomencladores/GradoService"
import Vue from "vue"

const state = () => ({
    grados: [],
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "nombre",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    }
})

const getters = {
    GRADOS: state => {
        return state.grados
    },
    GRADOS_PAG: state => {
        return state.pagination
    }
}

const mutations = {
    SET_GRADOS: (state, payload) => {
        state.grados = payload
    },

    SET_GRADOS_PAG: (state, payload) => {
        state.pagination = payload
    },

    ADD_GRADO: (state, payload) => {
        state.grados.push(payload)
    },

    UPDATE_GRADO: (state, payload) => {
        state.grados = state.grados.map(el => (el.id === payload.id ? payload : el))
    },

    DELETE_GRADO: (state, payload) => {
        state.grados = state.grados.filter(el => el.id !== payload.id)
    }
}

const actions = {
    LOAD_GRADOS: async ({ commit, state }, { filter, gradoEstado }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }
            let { data, status, headers } = await GradoService.get({ filter, gradoEstado, ...pagination })
            if (status === 200) {
                commit("SET_GRADOS", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los grados, inténtelo nuevamente"
            })
        }
    },

    LOAD_ALL_GRADOS: async ({ commit }) => {
        try {
            let { data, status } = await GradoService.getAll()
            if (status === 200) {
                commit("SET_GRADOS", data)
                return data
            }
        } catch (error) {
            if (error.response) {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    LOAD_ALL_RECORDS_GRADOS: async ({ commit }) => {
        try {
            let { data, status } = await GradoService.getAllRecords()
            if (status === 200) {
                commit("SET_GRADOS", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los grados, inténtelo nuevamente"
            })
        }
    },

    LOAD_HISTORY_GRADO: async ({ commit }, payload) => {
        try {
            let { data, status } = await GradoService.getHistory(payload)
            if (status === 200) {
                commit("UPDATE_GRADO", data)
            }
            return null
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar el historial del grado, inténtelo nuevamente"
            })
        }
    },

    ADD_GRADO: async ({ commit }, payload) => {
        try {
            let { data, status } = await GradoService.post(payload)
            if (status === 201) {
                commit("ADD_GRADO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Agregando",
                    text: "El grado ha sido agregado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido agregar el grado, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    UPDATE_GRADO: async ({ commit }, payload) => {
        try {
            let { data, status } = await GradoService.put(payload)
            if (status === 200) {
                commit("UPDATE_GRADO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "El grado ha sido modificado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar el grado, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    DELETE_GRADO: async ({ commit }, payload) => {
        try {
            let { status, data } = await GradoService.delete(payload)
            if (status === 204) {
                commit("DELETE_GRADO", payload)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Eliminando",
                    text: "El grado ha sido eliminado satisfactoriamente"
                })
            }
            if (status === 200) {
                commit("UPDATE_GRADO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Deshabilitando",
                    text: "El grado ha sido deshabilitado satisfactoriamente"
                })
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido eliminar/deshabilitar el grado, inténtelo nuevamente"
            })
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
